import React from "react";
import sortBy from "lodash/sortBy";
import { useAuth } from "shared/context/auth";
import { useGetBulkTicketRate } from "../../dataloader";

export function useBulkTicketQuantityService(ticketFormId: string) {
  const { userDetail } = useAuth();
  const registrationParticipantId = React.useMemo(() => userDetail?.id, [userDetail?.id]);

  const { data: bulkTicketRateCard } = useGetBulkTicketRate({
    registrationParticipantId,
    ticketFormId
  });

  const applicableRates = React.useMemo(
    () => sortBy(bulkTicketRateCard?.applicableRates, ["lowerLimit"]),
    [bulkTicketRateCard?.applicableRates]
  );

  return { applicableRates };
}
